import { Catalogue } from './masterData'

export const PRODUCT_TYPE = {
  NORMAL: 'NORMAL',
  BUNDLE: 'BUNDLE',
} as const

export type ProductType = (typeof PRODUCT_TYPE)[keyof typeof PRODUCT_TYPE]

export interface BundleItem {
  catalogue: string
  price?: number
  specialPrice?: number
  quantity?: number
}

export interface BundlePricing {
  price?: number
  onlinePrice?: number
  specialPrice?: number
  specialPriceStartDate?: string | null
  specialPriceEndDate?: string | null
  slashPrice?: number
  slashPriceStartDate?: string | null
  slashPriceEndDate?: string | null
}

export type CreateProductPayload = Pick<
  Catalogue,
  | 'description'
  | 'dept'
  | 'section'
  | 'family'
  | 'subFamily'
  | 'uom'
  | 'vatClass'
  | 'activeOnline'
  | 'hideAggregators'
  | 'specialCategories'
  | 'classifications'
  | 'erpBrand'
  | 'erpCoo'
  | 'erpMarketingCode'
  | 'image'
  | 'isDisable'
  | 'onlineDesc'
  | 'onlinePackInfo'
  | 'qtyPerUom'
  | 'quantityStep'
  | 'uomPackagingInfo'
> & {
  productType?: ProductType
  bundleItems?: BundleItem[]
  pricing?: BundlePricing
}

export type CatalogueProductOption = {
  _id: string
  itemNo: string
  description: string
  image?: string | null
  onlineDesc?: string | null
  uomPackagingInfo?: string | null
  uom?: string | null
}
